import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        Bu uygulama Süleyman Demirel Üniversitesi Film Kulübü için 
        **[Buraya Kendi İsminizi Ekleyin]** tarafından geliştirilmiştir.
      </p>
    </footer>
  );
};

export default Footer;